exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search_field_component{position:relative;font-size:18px;padding-bottom:20px}.search_field_component label{position:absolute;left:17px;top:11px}.search_field_component span{position:absolute;top:10px;right:17px;color:#d4d7de;cursor:pointer}.search_field_component .shadow_effect{-webkit-box-shadow:0 7px 6px -6px #777;box-shadow:0 7px 6px -6px #777}.search_field_component #search-input{padding-left:43px;padding-right:43px;border-radius:23px !important;border:1px solid #aaa}.search_field_component input{width:100%;height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333}.search_field_component .fa-times-circle{color:var(--primary-light-blue)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/searchField/SearchField.styles.scss
// module id = 1516
// module chunks = 0